import {svgSupportsForeignObject} from 'BenchlingUtil';
import preferences from 'Preferences';

export enum AlignmentMapPreferences {
  ALIGNMENTS_BASES_TEXT_USE_GEOMETRIC_PRECISION = 'ALIGNMENTS_BASES_TEXT_USE_GEOMETRIC_PRECISION',
}

export function foreignObjectRenderingEnabled(): boolean {
  return (
    svgSupportsForeignObject && !preferences.get(SequenceMapPreferences.DISABLE_FOREIGN_OBJECT_RENDERING)
  );
}

export enum SequenceMapPreferences {
  DISABLE_FOREIGN_OBJECT_RENDERING = 'DISABLE_FOREIGN_OBJECT_RENDERING',
  // The value of this preference key was generated programmatically by VisibilityOptions and should be
  // cleaned up, since it applies to all maps (including circular)
  ORF_START_CODON = 'linear.orfs.orf-start-codon-value',
}
